// Karşılaştırma / seçim (B). Hedef: türkiye'de restoran teknoloji şirketleri, restoran yazılımları.
// Rakip adı YOK (landing-copy kuralı). Online sipariş platformu entegrasyonu Tilki özelliği olarak
// anılmaz (landing'de henüz duyurulmadı); POS/ÖKC entegrasyonu fiyat sayfasıyla aynı ifadeyle anılır.
export default [
  {
    t: 'p',
    text: 'Türkiye’de restoran teknoloji şirketleri genellikle birkaç alanda uzmanlaşır: adisyon ve masa yönetimi, yazarkasa (ÖKC) ve kartlı ödeme cihazları, QR menü, online sipariş platformları, stok ve maliyet takibi, sadakat programları ve muhasebe ile e-belge. Bir restoran bunların çoğunu birlikte kullanır; seçimi zorlaştıran da hangi şirketin hangi ihtiyacı karşıladığını ayırt etmektir.',
  },
  {
    t: 'p',
    text: 'Bu yazıda restoran teknolojisinin hangi parçalardan oluştuğunu, yerli bir sağlayıcıda nelere bakılacağını ve birden fazla çözümün birlikte nasıl kullanılacağını anlatıyoruz.',
  },
  { t: 'h2', text: 'Restoran teknolojisi hangi alanlardan oluşur?' },
  {
    t: 'table',
    head: ['Alan', 'Ne işe yarar?', 'Dikkat edilecek nokta'],
    rows: [
      [
        'Adisyon ve restoran otomasyonu',
        'Masa, sipariş, hesap ve personel yönetimi',
        'Diğer alanlarla aynı sistemde mi çalışıyor?',
      ],
      [
        'Yazarkasa (ÖKC) ve POS cihazı',
        'Mali fiş ve kartlı ödeme',
        'Mali mevzuata tabidir; adisyon sistemiyle entegrasyonu sorun',
      ],
      ['QR menü', 'Dijital menü ve masadan sipariş', 'Menü ayrı mı hazırlanıyor, yoksa ürünlerden mi geliyor?'],
      [
        'Online sipariş platformları',
        'Paket servis siparişi',
        'Komisyon modeli yaygındır; siparişler kasaya nasıl düşüyor?',
      ],
      ['Stok ve maliyet', 'Reçete, fire ve ürün maliyeti', 'Satıştan otomatik stok düşümü var mı?'],
      ['Sadakat ve kampanya', 'Tekrar gelen müşteriyi ödüllendirme', 'Müşteri verisi nerede tutuluyor?'],
      ['Muhasebe ve e-belge', 'e-Fatura, e-Arşiv, defter kayıtları', 'Mali müşavirinizin kullandığı sistemle uyum'],
    ],
  },
  {
    t: 'p',
    text: 'Bu alanların bir kısmını tek şirketten, bir kısmını farklı şirketlerden almak mümkündür. Ne kadar çok ayrı sistem kullanılırsa, aynı ürünü ve fiyatı birden fazla yerde güncelleme ihtiyacı o kadar artar.',
  },
  { t: 'h2', text: 'Yerli bir restoran teknoloji şirketinde nelere bakılmalı?' },
  {
    t: 'p',
    text: 'Türkiye’de faaliyet gösteren bir restoran için yerli bir sağlayıcının öne çıktığı konular genellikle yerel koşullarla ilgilidir:',
  },
  {
    t: 'list',
    items: [
      '**Türkçe arayüz ve destek:** Personelin ekranı hızlı okuyabilmesi ve bir sorun olduğunda aynı dilde, aynı saat diliminde destek alınabilmesi.',
      '**Yerel mevzuata uyum:** Yazarkasa ve mali fiş, e-belge, KVKK ve fiyat etiketi düzenlemeleri gibi konularda sistemin Türkiye’deki uygulamaya göre tasarlanmış olması.',
      '**TL fiyatlandırma:** Döviz bazlı aboneliklerde maliyet kurla birlikte değişir; TL fiyatlı planlar bütçeyi öngörülebilir kılar.',
      '**Yerel entegrasyonlar:** Türkiye’de yaygın kullanılan ÖKC/POS cihazları ve ödeme altyapılarıyla çalışabilmesi.',
    ],
  },
  {
    t: 'p',
    text: 'Yabancı çözümler de kullanılabilir; ama yerel mevzuat ve cihazlarla nasıl çalıştıklarını baştan sormak gerekir. Sağlayıcıya sorulacak soruların ayrıntılı listesini [kafe ve restoran yönetim programı seçimi](/blog/kafe-restoran-yonetim-programi-secimi) yazısında topladık.',
  },
  { t: 'h2', text: 'Birden fazla çözümü birlikte kullanmak' },
  {
    t: 'p',
    text: 'Pek çok restoran; adisyon sistemi, yazarkasa ve bir ya da birkaç online sipariş platformunu aynı anda kullanır. Bu durumda en çok zaman alan iş, aynı bilginin birden fazla yere girilmesidir: menüye yeni bir ürün eklemek, fiyat değiştirmek ya da günün cirosunu kanallardan toplamak. Sistemlerin birbirine bağlı olması, yani siparişin tek yerde görünmesi ve ürün ile fiyatın tek yerden güncellenmesi, bu yükü azaltır.',
  },
  {
    t: 'note',
    title: 'Pratik bir yaklaşım',
    text: 'Önce günlük işin merkezinde duracak sistemi (genellikle adisyon ve masa yönetimi) seçin, diğer çözümleri onunla birlikte çalışıp çalışmadığına göre değerlendirin.',
  },
  { t: 'h2', text: 'Tilki Otomasyon' },
  {
    t: 'p',
    text: 'Tilki Otomasyon, İstanbul merkezli bir restoran teknolojisi şirketidir. Adisyon ve masa yönetimi, QR menü ve masadan sipariş, [restoran stok takibi](/blog/stok-takibi-nasil-yapilir) ve ürün maliyeti, kampanya ve sadakat ile satış raporlarını tek pakette ve TL fiyatla sunar. Hugin ve Odeal POS cihazlarıyla entegre kullanım için ekibimizle görüşebilirsiniz. Ayrıntılar [özellikler](/ozellikler) ve [fiyatlar](/fiyatlar) sayfalarında.',
  },
  {
    t: 'cta',
    title: 'Sisteminizi birlikte değerlendirelim',
    text: 'Ücretsiz demo talep edin; bugün kullandığınız araçlarla birlikte nasıl çalışacağını konuşalım.',
    to: '/demo',
    label: 'Ücretsiz demo alın',
  },
];

export const faq = [
  {
    q: 'Restoran yazılımı yerli mi olmalı?',
    a: 'Zorunlu değil, ama Türkçe destek, TL fiyatlandırma ve yazarkasa, e-belge, KVKK gibi yerel konulara uyum açısından yerli sağlayıcılar genellikle daha az uyarlama gerektirir.',
  },
  {
    q: 'Adisyon programı yazarkasanın yerini tutar mı?',
    a: 'Hayır. Adisyon programı siparişi, masayı ve hesabı yönetir; mali fiş yükümlülüğü yazarkasa (ÖKC) veya e-belge ile karşılanır. İkisinin entegre çalışması, hesabın iki kez girilmesini önler.',
  },
  {
    q: 'Tek bir şirketten mi, farklı şirketlerden mi almalıyım?',
    a: 'İki yol da mümkün. Tek pakette gelen çözümler veri tekrarını azaltır; farklı şirketlerden alınan çözümlerde ise aralarındaki entegrasyonun ne kadar sorunsuz çalıştığını baştan sormak gerekir.',
  },
];
